<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<!-- <style>
#app {
  font-weight: 300;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: 'Source Sans Pro', sans-serif;
}

.full-height {
  min-height: 100vh;
}
</style> -->



// WEBPACK FOOTER //
// src/App.vue